import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LabOSTopbar } from './lib/labos';
import HomePage from '@/pages/HomePage';
import JobsPage from '@/pages/JobsPage';
import JobDetailPage from '@/pages/JobDetailPage';

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col h-screen">
        <LabOSTopbar appName="AICL Object Replacement" accentColor="#8b5cf6" />
        <main className="flex-1 overflow-auto bg-gradient-to-br from-slate-50 to-slate-100">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/jobs" element={<JobsPage />} />
            <Route path="/jobs/:id" element={<JobDetailPage />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
